<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,2C15,2,1,2,1,2C0.45,2,0,2.45,0,3C0,3,0,13,0,13C0,13.55,0.45,14,1,14C1,14,15,14,15,14C15.55,14,16,13.55,16,13C16,13,16,3,16,3C16,2.45,15.55,2,15,2C15,2,15,2,15,2ZM5,11C5,11,5,5,5,5C5,5,11,8,11,8C11,8,5,11,5,11C5,11,5,11,5,11Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Video',
} as DefineComponent
</script>
